import React, { useContext } from 'react';
import classnames from 'classnames';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useCurrentPromo } from '@wix/da-shared-react/pkg/utils/hooks/useCurrentPromo';
import SaleBanner from '@wix/da-shared-react/pkg/banners/SaleBanner';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BrowseLayout } from '../../../../../constants';
import PageContainer from '../PageContainer';
import DefaultPageContent from '../DefaultPageContent';
import MpBanner from './MpBanner';

import s from './BasePageLayout.scss';

export interface Props {
  layout: BrowseLayout;
  feedType?: string;
  title?: React.ReactNode;
  tagLine?: React.ReactNode;
  headerNavigation?: React.ReactNode;
  headerRightSideContent?: React.ReactNode;
  headerLeftSideContent?: React.ReactNode;
  headerIsStickyOnScrollUp?: boolean;
  customHeader?: React.ReactNode;
  withTabHeader?: boolean;
  withNavigation?: boolean;
  withNetworkBar?: boolean;
  wrapperClassName?: string;
  contentClassName?: string;
  headerClassName?: string;
  titleClassName?: string;
  allowSaleBanner?: boolean;
  hasTiers?: boolean;
  hasCoreMembership?: boolean;
  isLoggedIn?: boolean;
  children?: React.ReactNode;
}

const BasePageLayout: React.FC<Props> = ({
  title,
  tagLine,
  headerNavigation,
  headerRightSideContent,
  headerLeftSideContent,
  headerIsStickyOnScrollUp,
  feedType,
  children,
  withNavigation,
  withNetworkBar,
  wrapperClassName,
  contentClassName,
  headerClassName,
  titleClassName,
  customHeader,
  withTabHeader,
  allowSaleBanner = true,
  layout,
}) => {
  const isMobile = useContext(MobileContext);

  const mp_banner_d = useFlag('mp_banner_d');
  const isShowingMpBanner = !isMobile && mp_banner_d && allowSaleBanner;

  const currentPromo = useCurrentPromo('self');
  const isShowingCorePromo = allowSaleBanner && currentPromo;
  const isShowingBanner = isShowingCorePromo;

  const isCoast2Coast = layout === BrowseLayout.MobileGrid;
  return (
    <PageContainer
      title={title}
      tagLine={tagLine}
      headerNavigation={headerNavigation}
      headerLeftSideContent={headerLeftSideContent}
      headerRightSideContent={headerRightSideContent}
      headerIsStickyOnScrollUp={headerIsStickyOnScrollUp}
      withNavigation={withNavigation}
      withNetworkBar={withNetworkBar}
      wrapperClassName={wrapperClassName}
      headerClassName={headerClassName}
      titleClassName={titleClassName}
      customHeader={customHeader}
      withTabHeader={withTabHeader}
    >
      <div
        className={classnames(
          s['root'],
          s[`feed-${feedType}`],
          isShowingBanner && s['with-banner'],
          isCoast2Coast && s['coast2coast'],
          contentClassName
        )}
      >
        {isShowingCorePromo && (
          <SaleBanner
            className={s['sale-banner']}
            endDate={currentPromo!.endDate}
            discountValuePercent={currentPromo!.discountValuePercent}
            referralType={ReferralType.PROMOTION_BANNER_HOME}
          />
        )}
        {isShowingMpBanner && <MpBanner className={s['sale-banner']} />}
        {children ? children : <DefaultPageContent />}
      </div>
    </PageContainer>
  );
};
BasePageLayout.displayName = 'BasePageLayout';

export default BasePageLayout;
